import Cookies from 'universal-cookie';
import $ from 'jquery';
import { TileImage } from 'ol/source.js';
import {
    BrowserRouter as Router,
    Redirect,

  } from 'react-router-dom'

const monthTH=['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย','ก.ค.','ส.ค.','ก.ย','ต.ค','พ.ย','ธ.ค.']
const cookies=new Cookies();
var srcLongdo = new TileImage({ url: "http://ms.longdo.com/map/msn-server/img.php?HD=1&zoom={z}&x={x}&y={y}&mode=icons&key=e7e08f7f6a256213042d69020f6628fe&proj=epsg3857" })

export function getSrcLongdo() {
    return srcLongdo;
}

export function setENSrcMap() {
    srcLongdo.setUrl("http://ms.longdo.com/map/msn-server/img.php?HD=1&zoom={z}&x={x}&y={y}&mode=icons-en&key=e7e08f7f6a256213042d69020f6628fe&proj=epsg3857" );
}

export function setTHSrcMap() {
    srcLongdo.setUrl("http://ms.longdo.com/map/msn-server/img.php?HD=1&zoom={z}&x={x}&y={y}&mode=icons&key=e7e08f7f6a256213042d69020f6628fe&proj=epsg3857" );
}

export function getMonthTHFromInt(month) {
    return monthTH[month-1];
}
export function getFullDate(date){
    let d = checkText(date,"-");
    if(d=="-")
        return d;
    else{
        if(date.split("-").length==3)
            d = parseInt(date.split("-")[0]) +" "+ getMonthTHFromInt(parseInt(date.split("-")[1])) + (parseInt(date.split("-")[2])+543-2500);
        else if(date.split("-").length==2)
            d = getMonthTHFromInt(parseInt(date.split("-")[0])) + (parseInt(date.split("-")[1])+543-2500);
    }
    return d;
}
export function squareDist(coord1, coord2) {
    let dx = coord1[0] - coord2[0];
    let dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
} 
export function getMainCookie(isNotGotoLogin){ 
    if(cookies.get('ft') && cookies.get('ft') != null){
        return(cookies.get('ft'));
    }
    else {
        if(isNotGotoLogin == undefined || isNotGotoLogin == false){
            document.location.href="/"; 
            //return [{user_id:"",login_name:"",token:""}];
            document.location.reload();
        }
        
        return {user_id:"",login_name:"",token:"",remember:false};
    }
          
    
}
export function deleteCookie(name){
    cookies.remove(name);
    // document.location.reload();
}
export function groupBy( array ,f )
{
  var groups = {};
  array.forEach( function( o )
  {
    var group = JSON.stringify( f(o) );
    groups[group] = groups[group] || [];
    groups[group].push( o );  
  });
  return Object.keys(groups).map( function( group )
  {
    return groups[group]; 
  })
}
export function checkStatus(res){
    if(res.status!=200){
        alert(res.status+"("+res.statusText+") คุณอยู่ในระบบนานเกินระยะเวลาที่กำหนด กรุณาเข้าสู้ระบบใหม่อีกครั้ง");
        document.location.href="/"; 
        //document.location.reload();
        return [];
    }
    return res.json();
    // let text = res.text();

    // return text.length ? JSON.parse(text) : {RESULT_DATA:[]}
}
export function setLoader(isShow){
    if(isShow)
        $("#loadder").show();
    else
        $("#loadder").hide();
}

export function checkText(txt,txtEmp,nLimit){
    if(!txt || txt == null || txt.toString().trim() == "")
        txt = txtEmp;
    if(nLimit && txt && txt != null && txt.length > nLimit-3)
        txt = txt.substring(0,nLimit-3) +"";//"..."
    return txt;
}

export function checkPrivileges(mode){
    let c = cookies.get('ft');
    console.log("toto",c,mode)
    if(c.user_level<3)
        return true;

    if(!c.privileges)
        return true;
    if(mode=="report")
        return !!c.privileges.is_view_report;
    else if(mode=="view_poi")
        return !!c.privileges.is_view_poi;
    else if(mode=="edit_poi")
        return !!c.privileges.is_edit_poi;
    else if(mode=="command")
        return !!c.privileges.is_send_command;
    else if(mode=="history")
        return !!c.privileges.is_view_history;
    else if(mode=="tracking")
        return !!c.privileges.is_view_tracking;
    else
        return true;

}


// WEBPACK FOOTER //
// ./src/app/util/util.js